export default [{
  path: '/areaEntrega/',
  name: 'areaEntrega',
  title: 'AreaEntrega',
  component: () => import('../views/AreaEntregaView.vue'),
  redirect: { name: 'areaEntrega-listar' },
  children: [
    {
      path: 'welcome',
      name: 'areaEntrega-listar',
      component: () => import('../views/AreaEntregaWelcomeView.vue'),
      meta: {
        title: 'Área de entrega',
      },
    },
    {
      path: 'add',
      name: 'areaEntrega-cadastrar',
      component: () => import('../views/AreaEntregaFormView.vue'),
      meta: {
        title: 'Cadastrar área de entrega',
      },
    },
  ],
}];
